import React from 'react';
import QuestionFlow from './CTQuestionFlow';
import RecommendedProducts from './CTProductsRecommended';
import QuestionMap from './CTQuestionMap';
import PropTypes from 'prop-types';

const CTGuide = ({ enableQuestionMap, ...rest}) => {
  return (
    <>
      <div className="col-7">
        <QuestionFlow isFullHeight={true} {...rest} />
      </div>
      <div className="col-5">
        <RecommendedProducts isFullHeight={!enableQuestionMap} {...rest} />
        { enableQuestionMap && <QuestionMap /> }
      </div>
    </>
  );
};

CTGuide.propTypes = {
  enableQuestionMap: PropTypes.bool
};
export default CTGuide;
